export const pillars = ['Assessment', 'Load Progression', 'Fiber Remodeling', 'Prevention'];
export const volumes = [{
  n: 1,
  emoji: '📘',
  title: 'The Biology of Repair',
  desc: 'A deep dive into the science of exactly what happens when a muscle tears or is strained. This volume teaches you how to identify the severity of your injury and what your tissue actually needs at each stage.'
}, {
  n: 2,
  emoji: '📗',
  title: 'The Pain-Free Reset',
  desc: 'Focused on "unlocking" the muscle without causing further damage. It employs joint mobility and breathing techniques to reduce "guarding", enabling the recovery of basic movement without pain.'
}, {
  n: 3,
  emoji: '📙',
  title: 'The Loading Blueprint',
  desc: 'The core of recovery. This volume teaches how to safely apply load to an injured muscle — how much, how often, and how to know when your fibers are ready for the next step.'
}, {
  n: 4,
  emoji: '📕',
  title: 'Functional Integration',
  desc: 'Movement re-patterning and core stability. How to reconnect an injured muscle with the rest of the body, using kinetic chain work so surrounding muscles support the injured area and your body never develops dangerous compensations.'
}, {
  n: 5,
  emoji: '📓',
  title: 'The Performance Bridge',
  desc: 'Designed for the final phase. It teaches the transition from rehabilitation to the real world — running, jumping, lifting weights or working — with clear criteria so you return without fear.'
}, {
  n: 6,
  emoji: '📔',
  title: 'The Shield Protocol',
  desc: 'Define weekly "shielding" routines to ensure the injury never returns, optimizing tissue flexibility and muscular resilience for the future.'
}];
export const volumeIncludes = ['Step-by-step visual protocols', 'Injury severity assessment', 'Load progression checkpoints', 'Return-to-action criteria', 'Daily practice checklists', 'Printable tracking sheets', 'Home and gym progressions', 'Ready to apply from today'];
export const bonuses = [{
  n: '01',
  title: 'The Hamstring Restoration Protocol',
  desc: 'Specific high-level protocols for the most common injury in sports. From the initial strain all the way to high-speed running, with clear criteria at every stage.',
  price: '$47',
  cover: 'https://cdn.magicpatterns.com/uploads/g1dBLgJcQFriwyBoZccdpv/BONO1_WEB.webp'
}, {
  n: '02',
  title: 'The Lower Back Shield / Lumbar Resilience',
  desc: 'A guide to managing muscle-related back pain and core dysfunction to protect your spine during recovery — and to keep it protected afterwards.',
  price: '$37',
  cover: 'https://cdn.magicpatterns.com/uploads/4VDE6cV854ViVLrNjEXQHH/BONO_2_WEB.webp'
}, {
  n: '03',
  title: 'The Calf & Achilles Anchor',
  desc: 'Targeted work for the lower leg. Solve chronic stiffness and rebuild explosive power in your gastrocnemius and soleus without risking a re-tear.',
  price: '$47',
  cover: 'https://cdn.magicpatterns.com/uploads/di7qTRoe8sgsF1VnkSPZ5s/BONO_3_WEB.webp'
}, {
  n: '04',
  title: 'The Shoulder Armor: Rotator Cuff Matrix',
  desc: 'Stabilization and recovery for the deltoids and rotator cuff. Essential for anyone who trains upper body and needs to press overhead again with confidence.',
  price: '$39',
  cover: 'https://cdn.magicpatterns.com/uploads/qMTqsLysaCsVHjgzM5wzJ3/BONO_4_WEB.webp'
}, {
  n: '05',
  title: 'The Groin & Adductor Solution',
  desc: 'Specific protocols for pelvic stability and adductor strains. Fix the "hidden" imbalances that cause groin pain and keep coming back season after season.',
  price: '$27',
  cover: 'https://cdn.magicpatterns.com/uploads/rehhdJmhR12KqKajQKiG9p/BONO_5_WEB.webp'
}];
